import SideBar from "../Components/SideBar";
import React, { createContext, useContext, useEffect, useState } from 'react';
import { getCitiesByUserId } from "../Services/citiesApi";
import LanguageSelector from "../Components/heidiDashboard/LanguageSelector";
import MultiSocialLinks from "../Components/terminalDashboard/SocialMediaLinks";
import SearchableDropdown from "../Components/SearchableDropdown";
import ServiceForm from "../Components/heidiDashboard/ServceForm";
import CategoryScraperForm from "../Components/heidiDashboard/CreateCategory";
import { getAppDashboardConfig, postAppDashboardConfig, getServicesHeidi } from "../Services/appDashboardApi";
import { FaEdit, FaTrash } from "react-icons/fa";
import { deleteAppDashService } from "../Services/terminal";
import AddService from "../Components/heidiDashboard/AddService";
import { validateURL } from "../Components/util/linkValidation";
import { useTranslation } from "react-i18next";
export const getStatusColor = (status) => {
    switch (status) {
        case 1:
            return 'bg-green-600'; // Active
        case 2:
            return 'bg-red-600'; // Rejected
        case 3:
            return 'bg-yellow-500'; // Pending
        default:
            return 'bg-gray-400'; // Unknown/Default
    }
};

const AppConfigContext = createContext();
export const useAppConfig = () => useContext(AppConfigContext);
const AppDashboard = () => {
    const [appConfig, setAppConfig] = useState({
        cityId: null,
        selectedCity: null,
        categoryIds: null,
        selectedCategoriesIds: null,
        serviceTypeIds: [],
        selectedServices: []
        , languages: [],
        scrapers: [],
        selectedLanguage: []
        , scrapperConfig: [],
        selectedScrapper: [{ link: "" }]
        , socialAccountConfig: []
        , selectedSocialAcscraperscount: [{ id: Date.now(), platform: "linkedin", url: "" }]
    });
    const [openEditService, setOpenEditService] = useState(false);
    const { t } = useTranslation();
    const [success, setSuccess] = useState(null);
    const [addServiceSuccess, setAddServiceSuccess] = useState(null);
    const fetchAllAppDashboardListing = async () => {
        try {
            const res = await getAppDashboardConfig(appConfig?.selectedCity?.value);
            const list = res.data.data || {};
            setAppConfig((prev) => {
                return ({
                    ...prev,
                    categoryIds: list?.categories?.map((data) => data.id),
                    serviceTypeIds: list?.services,
                    languages: list?.languages || [],
                    scrapperConfig: list?.webScrappers || [],
                    socialAccountConfig: list?.socialMedia?.map((data) => ({ platform: data?.accounttype, url: data?.link })) || [],
                })
            });
            setIsValidScraperLink((prev) => {
                let len = list?.webScrappers?.length
                return Array(len).fill(true);
            })
        } catch (e) {
            console.error(e)
        }
    };
    function handleAddServiceSuccess(value) {
        setAddServiceSuccess(value);
        setTimeout(() => {
            setAddServiceSuccess(null);
        }, 5000);
    }
    async function handleSucess(value) {
        setSuccess(value);
        await fetchAllAppDashboardListing();
        setTimeout(() => {
            setSuccess(null);
        }, 2000);
    }
    const [citiesList, setCities] = useState([]);
    const [servicesHeidi, setServicesHeidi] = useState();
    const [loader, setLoader] = useState(false);
    const handleScraperChange = (index, key, value) => {
        const updated = [...appConfig?.selectedScrapper];
        updated[index][key] = value;
        setAppConfig((prev => ({ ...prev, selectedScrapper: updated })));
    };
    const addScraper = () => {
        setAppConfig((prev) => ({ ...prev, selectedScrapper: [...prev.selectedScrapper, { link: "" }] }));
        setIsValidScraperLink((prev) => ([...prev, true]));
    };
    const handleRemoveScrapper = (index) => {
        const updated = [...appConfig.selectedScrapper];
        updated.splice(index, 1);
        setAppConfig((prev) => ({ ...prev, selectedScrapper: updated }));
        setIsValidScraperLink((prev) => {
            const newValidLinks = [...prev];
            newValidLinks.splice(index, 1);
            return newValidLinks;
        });
    }
    useEffect(() => {
        if (appConfig?.cityId) fetchAllAppDashboardListing();
    }, [appConfig?.selectedCity]);
    useEffect(() => {
        if (appConfig?.scrapperConfig.length > 0) {
            setAppConfig((prev) => ({ ...prev, selectedScrapper: appConfig?.scrapperConfig }))
        } else {
            setAppConfig((prev) => ({ ...prev, selectedScrapper: [{ link: "" }] }))
        }
    }, [appConfig?.scrapperConfig])
    useEffect(() => {
        getCitiesByUserId().then((citiesResponse) => {
            setCities(citiesResponse?.data?.data?.map((city) => {
                if (appConfig?.cityId === city?.id) {
                    setAppConfig((prev) => ({ ...prev, selectedCity: { label: city?.name, value: city?.id } }))
                }
                return { label: city?.name, value: city?.id }
            }));
        });
    }, [])
    function handleSubmit() {
        const data = {
            cityId: appConfig?.selectedCity?.value,
            categories: appConfig?.selectedCategoriesIds?.map((category) => category?.id),
            services: appConfig?.serviceTypeIds?.map((service) => service?.id),
            languages: appConfig?.selectedLanguage?.map((lang) => lang?.value)
        };
        setLoader(true);
        postAppDashboardConfig(appConfig?.selectedCity?.value, data).then((res) => {
            handleSucess(t("sucess_message"));
        }).catch((err) => {
            console.error("Error", err);
        }).finally(() => {
            setTimeout(() => {
                setLoader(false);
            }, 2000);
        });
    }

    const handleDeleteService = async (id) => {
        try {
            const res = await deleteAppDashService(id);
            if (res.status === 200) {
                await fetchAllAppDashboardListing();
            }
        } catch (e) {
            console.error(e)
        }
    }
    const [isValidScraperLink, setIsValidScraperLink] = useState([true]);
    const handleValidLink = (value, index) => {
        handleScraperChange(index, "link", value)
        if (!validateURL(value)) {
            setIsValidScraperLink((prev) => {
                const newValidLinks = [...prev];
                newValidLinks[index] = false;
                return newValidLinks;
            });
        } else {
            setIsValidScraperLink((prev) => {
                const newValidLinks = [...prev];
                newValidLinks[index] = true;
                return newValidLinks;
            });
        }
    }

    return <div className="bg-gray-800 body-font relative min-h-screen">
        <SideBar />
        <AppConfigContext.Provider value={{ appConfig, setAppConfig }}>
            <div className="container w-auto px-5 py-2 bg-gray-900">
                {success && <div className="top-4 fixed right-2 p-3 bg-green-100 text-green-800 rounded-md text-xs">{success}</div>}
                {addServiceSuccess && <div className="top-4 fixed right-2 p-3 bg-green-100 text-green-800 rounded-md text-xs">{addServiceSuccess}</div>}
                <div className="p-6 m-auto flex flex-col">
                    <h2 className="text-2xl font-bold text-white mt-6">Heidi App Dashboard</h2>
                    <form className="max-w-sm mt-6 mb-4">
                        <label htmlFor="countries" className="block mb-2 text-sm font-medium text-white">{t("select_city")}</label>
                        <SearchableDropdown
                            options={citiesList.map((city) => ({ id: city.value, name: city.label }))}
                            selected={appConfig.selectedCity ? [{ id: appConfig.selectedCity.value, name: appConfig.selectedCity.label }] : []}
                            onSelect={(option) => { setAppConfig((prev) => ({ ...prev, selectedCategoriesIds: null, selectedCity: { label: option.name, value: option.id }, cityId: option.id ?? null })) }}
                            onRemove={() => { setAppConfig((prev) => ({ ...prev, selectedCategoriesIds: null, selectedCity: null, cityId: null })) }}
                            placeholder={t("select_city")}
                            sort="alphabetics"
                        />
                    </form>
                    <CategoryScraperForm success={success} handleSucess={handleSucess} />
                    <div>
                        <h4 className="text-2xl my-4 text-white font-bold">{t("Services")}</h4>
                        <div className="flex flex-wrap gap-2">
                            {appConfig?.serviceTypeIds?.map((service, index) => (
                                <div key={index} className="flex flex-row justify-between gap-2 items-start px-3 py-2 m-1 bg-white rounded-lg shadow text-left w-[250px] border border-gray-100">

                                    <div>
                                        <div className="flex flex-row gap-1">
                                            <h6 className="text-sm font-semibold text-gray-800 text-left truncate overflow-hidden whitespace-nowrap w-[150px]">
                                                {service?.name}
                                            </h6>
                                        </div>
                                        <p className="text-xs text-gray-500 truncate">{service?.serviceType?.name}</p>

                                    </div>
                                    <div className="flex space-x-2 self-center">
                                        <  div className={`h-[10px] w-[10px] rounded-[50%] ${getStatusColor(service?.statusId ?? 1)} self-center`}></div>
                                        <FaEdit
                                            className="text-blue-500 hover:text-blue-700 cursor-pointer"
                                            onClick={() => setOpenEditService(service)}
                                        />
                                        <FaTrash
                                            className="text-red-500 hover:text-red-700 cursor-pointer"
                                            onClick={() => handleDeleteService(service?.id)}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                        {openEditService?.id && <AddService selectedService={openEditService} isEdit={true} cityId={appConfig?.cityId} handleSucess={handleSucess} close={() => setOpenEditService(false)} />}
                    </div>
                    <ServiceForm success={setAddServiceSuccess} handleSucess={handleSucess} />
                    <LanguageSelector />
                    <button disabled={!appConfig?.cityId || loader} onClick={handleSubmit} className="rounded-xl py-2 px-6 font-bold self-center mt-4 w-fit
             bg-green-500 text-white hover:bg-green-600
             disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed">
                        {loader ? (
                            <div className="w-5 h-5 rounded-full border-2 border-white border-t-transparent animate-spin"></div>
                        ) : (
                            t("submitLabel")
                        )}
                    </button>
                </div>
            </div>
        </AppConfigContext.Provider>
    </div>
};

export default AppDashboard;